import React from 'react';
import cx from 'classnames';

import './styles/section.scss';
import Breadcrumbs from '../breadcrumbs/breadcrumbs';

type SectionProps = {
  title?: string;
  altText?: string;
  headText?: string;
  largeTitle?: string;
  children?: any;
  additionalClass?: string;
  contactHeadText?: string;
  ignoreBreadcrumbs?: boolean;
  alignBreadcrumbs?: boolean;
  titleId?: string;
  textId?: string;
  contactId?: string;
  id?: string;
  inlineStyle?: any;
};

const Section: React.FC<SectionProps> = ({
  title,
  altText,
  headText,
  largeTitle,
  children,
  additionalClass,
  contactHeadText,
  ignoreBreadcrumbs = false,
  alignBreadcrumbs = false,
  titleId,
  textId,
  contactId,
  id,
  inlineStyle,
}) => {
  return (
    <div id={id} className={cx('section', additionalClass)} title={altText ? altText : ''} style={inlineStyle}>
      <div className="shell">
        <div className="section__inner">
          <div className="section__head">
            {!largeTitle && title && (
              <h2 id={titleId} className="h3">
                {title}
              </h2>
            )}

            {largeTitle && title && (
              <React.Fragment>
                {!ignoreBreadcrumbs && (
                  <div className={alignBreadcrumbs ? 'section__head__breadcrumbs shell-alt' : 'section__head__breadcrumbs'}>
                    <Breadcrumbs sectionBreadcrumbs="true" />
                  </div>
                )}
                <h1 id={titleId} className="h1">
                  {title}
                </h1>
              </React.Fragment>
            )}

            {headText && <p id={textId}>{headText}</p>}
            {contactHeadText && (
              <p id={contactId} className="section__groups--custom">{contactHeadText}</p>
            )}
          </div>

          <div className="section__body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Section;
